import { getPaddedString } from '../helpers';
var CONSTRUCTION_STATUS_SORT_VALUES = {
  finished: 2,
  inProject: -1
};
export function sortByNames(prevSection, nextSection) {
  var prevValue = getSortStringBySection(prevSection);
  var nextValue = getSortStringBySection(nextSection);
  if (prevSection.deadlineData.text === nextSection.deadlineData.text) {
    return prevValue.localeCompare(nextValue, 'kn', {
      numeric: true
    });
  }
  return 0;
}
export function sortByType(prevSection, nextSection) {
  var prevSortValue = CONSTRUCTION_STATUS_SORT_VALUES[prevSection.constructionStatus] || 1;
  var nextSortValue = CONSTRUCTION_STATUS_SORT_VALUES[nextSection.constructionStatus] || 1;

  // Если сортируются корпуса/секции разных видов, то сортируем их по важности статуса
  if (prevSortValue !== nextSortValue) {
    return nextSortValue - prevSortValue;
  }
  return 0;
}
export function sortByDates(prevSection, nextSection) {
  if (prevSection.deadlineData.text === nextSection.deadlineData.text) {
    return 0;
  }
  [prevSection, nextSection].forEach(function (section) {
    if (section.deadlineData.text.includes('Сдан')) {
      section.deadlineData.year = 1970;
    }
  });
  var prevDate = new Date(prevSection.deadlineData.year || 2999, (prevSection.deadlineData.quarter || 1) * 3 - 1, 1);
  var nextDate = new Date(nextSection.deadlineData.year || 2999, (nextSection.deadlineData.quarter || 1) * 3 - 1, 1);
  return prevDate < nextDate ? -1 : prevDate > nextDate ? 1 : 0;
}
export function sortFlatsByRooms(prevFlat, nextFlat) {
  return prevFlat.roomCount - nextFlat.roomCount;
}
export function getSortStringBySection(section) {
  var sectionName = section.house.sections.length > 1 ? section.sectionData.number : '';
  var rawHouseName = section.house.name.replace(/\D/g, '');
  var formattedHouseName = getPaddedString(rawHouseName, 5, '0');
  return "".concat(formattedHouseName, "_").concat(sectionName);
}